import { TooltipProvider } from "@resume-studio/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router-dom";

import { queryClient } from "../libs/query-client";
import { Toaster } from "./toaster";

// Intentionally minimal compared to the consumer app's Providers stack:
//
// - No PostHog / GA / Pixel — admin sessions are internal, never tracked.
// - No locale provider — admin is English-only.
// - No theme switcher — light mode is the only mode (Stripe-style aesthetic).
// - No FontProvider — typography is locked at the CSS layer in `main.css`.
// - No AuthRefreshProvider — refresh interception lives in the dedicated
//   admin axios instance (`libs/axios.ts`), no tree-walking required.
//
// Anything we add here later should require an explicit reason; admin should
// stay this lean so it boots fast and never ships a tracker by mistake.
export const AdminProviders = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={250}>
          <Outlet />
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};
